
const digest = '9371dee6581d401574304b9a53fcd16ceef98af223348e30d291ab7a8bcfd5ff';
const classes = {"wrapper":"_wrapper_14o9x_1","title":"_title_14o9x_9","item":"_item_14o9x_16"};
const css = `._wrapper_14o9x_1 {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

._title_14o9x_9 {
  font-size: 14px;
  color: #97a4ba;
  margin-top: 15px;
  cursor: pointer;
}

._item_14o9x_16 {
  width: 40px;
  height: 20px;
  border-radius: 4px;
  margin: 4px 0;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  